/**
 * The name of the place an address of this interface opens, as the catalog key of its heading. A screen
 * drawn before anything of the place could be read (the session's outage) still says where the person
 * is, as its H1, and the outage's own heading comes under it (D158, D163).
 */
export class Place {
	/** Each place by its address, the first that matches; the screens before the frame by their own name */
	static #named: [RegExp, string][] = [
		[/^\/$/, 'nav.overview'],
		[/^\/organizations(\/|$)/, 'nav.organizations'],
		[/^\/account$/, 'nav.account'],
		[/^\/security$/, 'nav.security'],
		[/^\/activity$/, 'nav.activity'],
		[/^\/tokens$/, 'nav.tokens'],
		[/^\/tokens\/new$/, 'tokens.new'],
		[/^\/connections$/, 'nav.connections'],
		[/^\/notifications$/, 'nav.notifications'],
		[/^\/invitations$/, 'received.title'],
		[/^\/invitations\/[^/]+$/, 'place.invitation'],
		[/^\/consent$/, 'place.consent'],
		[/^\/connect$/, 'place.connect'],
		[/^\/signin(\/factor)?$/, 'signin.title'],
		[/^\/signup$/, 'signup.title'],
		[/^\/reset$/, 'reset.title']
	];

	/** The catalog key naming the place `path` opens; Beyond Accounts itself for any other */
	static key(path: string): string {
		return Place.#named.find(([address]) => address.test(path))?.[1] ?? 'place.accounts';
	}
}
